export const MEASUREMENT_SYSTEM_CONTEXT_ID = 'measurementSystem';
